import { render, staticRenderFns } from "./Woof.vue?vue&type=template&id=0575bd56&scoped=true&"
import script from "./Woof.vue?vue&type=script&lang=js&"
export * from "./Woof.vue?vue&type=script&lang=js&"
import style0 from "./Woof.vue?vue&type=style&index=0&id=0575bd56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0575bd56",
  null
  
)

export default component.exports